import { DataTable } from './components/MediaDownload/data-table';
import { getColumns } from './components/MediaDownload/columns';
import supabase from '@/utils/supabase';
import type { Database } from '@/types/database.types';
export type Upload = Database['public']['Tables']['uploads']['Row'];
type Project = Database['public']['Tables']['projects']['Row'];
import { ChevronDown, ChevronRight } from 'lucide-react';
import { type Row } from '@tanstack/react-table';

const categoryLabels: Record<string, string> = {
  video: 'Videos',
  image: 'Images',
  audio: 'Audio',
};

export default function MediaTab({
  project,
  uploads,
}: {
  project: Project;
  uploads: Upload[];
}) {
  function renderMediaGroupHeaders(row: Row<Upload>) {
    const category = row.getValue('category') as string;
    return (
      <div className="flex items-center gap-2 font-semibold">
        {row.getIsExpanded() ? (
          <ChevronDown className="size-4" />
        ) : (
          <ChevronRight className="size-4" />
        )}
        {categoryLabels[category] || category}
        <span className="text-muted-foreground font-normal">
          ({row.subRows.length})
        </span>
      </div>
    );
  }

  async function handleDownload(projectId: string, uploadId: string) {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session?.access_token) {
      console.error('No active session');
      return;
    }

    const response = await fetch(
      `/api/team/projects/${projectId}/media/${uploadId}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${session?.access_token}`,
        },
      }
    );
    const data = await response.json();
    if (!response.ok) {
      console.error('Download failed:', data.error);
      return;
    }
    const link = document.createElement('a');
    link.href = data.url;
    link.download = data.file_name;
    link.click();
  }

  const columns = getColumns(handleDownload, uploads, project);
  return (
    <div>
      <DataTable
        columns={columns}
        data={uploads}
        initialGrouping={['category']}
        renderGroupHeader={renderMediaGroupHeaders}
        emptyMessage="No files uploaded."
      />
    </div>
  );
}
